import React from 'react'
import './Home_about.css'
import Heading_title from '../../common-components/common-title/heading-title/Heading_title'
import Black_btn from '../../common-components/common-button/black-btn/Black_btn'

const Home_about = () => {
    return (
        <>
            <section className='Home_about_sec'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-7 my-auto'>
                            <div className='contsec'>
                                <Heading_title title={'About Us'} subtitle={'Scroma Venture Counting Machines'} />

                                <p className='sbtcont'>We are a premier manufacturer, distributor, and importer of currency counting
                                    solutions, known for our unwavering commitment to reliability and precision.
                                </p>
                                <p className='sbtcont'>Whether you're a bank, a retail business, or any organization that handles cash, we have the advanced equipment and expertise to meet your needs. Let us help you achieve flawless currency counting and take the stress out of your daily operations.
                                </p>
                                <br></br>
                                <br></br>
                                <Black_btn btn_name={'Know More'} btn_link={'/about-us'} />
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='imgsec'>
                                <img className='machineimg' src={process.env.PUBLIC_URL + '/assets/images/home/about/machine.png'} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Home_about